<script setup lang="ts">
// Full-surface free-user paywall: the real page stays rendered and lightly
// blurred behind a centered CuriosityLock ("sees everything, accesses nothing").
// Drop it as the last child of a `position: relative` page root. A light blur +
// light scrim keep the real product clearly visible behind the lock, which
// converts better than hiding it completely.
import type { PaywallSurface } from '~/constants/paywallSurfaces';

const {
  requiredTier = 'PRO',
  requiredTierLabel,
  title,
  surface,
  teaser = '',
  points = [],
} = defineProps<{
  requiredTier?: 'MEMBER' | 'PRO';
  requiredTierLabel?: string;
  title: string;
  surface: PaywallSurface;
  teaser?: string;
  points?: string[];
}>();

// The tier label default is resolved inside CuriosityLock (translated), so an
// omitted prop is simply passed through as undefined.
</script>

<template>
  <div
    class="absolute inset-0 z-[80] flex items-start justify-center overflow-y-auto bg-bg/40 px-4 py-10 backdrop-blur-[4px] tablet:py-16"
  >
    <BillingCuriosityLock
      class="w-full max-w-[600px]"
      :required-tier="requiredTier"
      :required-tier-label="requiredTierLabel"
      :title="title"
      :surface="surface"
      :teaser="teaser"
      :points="points"
    />
  </div>
</template>
